import { Box } from "@rebass/grid";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { Modal, TextField } from "@rentiohq/web-shared/dist/components";
import React, { useState } from "react";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string) => void;
}

export const SaveFilterModal: React.FC<IProps> = ({
  isOpen,
  onClose,
  onSave,
}) => {
  const [name, setName] = useState("");

  const handleSave = () => {
    if (name.trim()) {
      onSave(name.trim());
      setName("");
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      onClose={onClose}
      heading={getLocalizedText("application.filters.save.title")}
      actions={[
        {
          content: getLocalizedText("system.cancel"),
          appearance: "outline",
          onClick: onClose,
        },
        {
          content: getLocalizedText("system.save"),
          appearance: "primary",
          onClick: handleSave,
          isDisabled: !name.trim(),
        },
      ]}
    >
      <Box p={3}>
        <Box mb={2}>
          {getLocalizedText("application.filters.save.description")}
        </Box>
        <TextField
          label={getLocalizedText("application.filters.name.label")}
          value={name}
          name="filterName"
          onChange={(e: any) => setName(e.target.value)}
          placeholder={getLocalizedText("application.filters.name.placeholder")}
          autoFocus
        />
      </Box>
    </Modal>
  );
};
